import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { theme, Badge } from 'antd';
import {
  HomeOutlined,
  UserOutlined,
  SolutionOutlined,
  LockOutlined,
  BellOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { StoreContext } from '../store/index';

function BottomNav({ pendingCount = 0, onOpenRequests }) {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;
  const { token } = theme.useToken();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = key => (key === '/' ? pathname === '/' : pathname.startsWith(key));

  const tabs = [
    { key: '/news', icon: <SolutionOutlined />, label: formatMessage({ id: 'layout.news' }) },
    { key: '/', icon: <HomeOutlined />, label: formatMessage({ id: 'layout.games' }) },
    { key: '/teams', icon: <TeamOutlined />, label: formatMessage({ id: 'layout.teams' }) },
    { key: '/profile', icon: <UserOutlined />, label: formatMessage({ id: 'layout.profile' }) },
  ];

  if (user.isAdmin) {
    tabs.unshift({ key: '/admin', icon: <LockOutlined />, label: formatMessage({ id: 'layout.admin' }) });
  }

  const btnBase = {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
    padding: '6px 4px',
    borderRadius: 8,
    fontFamily: token.fontFamily,
    transition: 'color 0.15s',
    WebkitTapHighlightColor: 'transparent',
    outline: 'none',
  };

  return (
    <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100 }}>
      <div style={{
        maxWidth: 720,
        margin: '0 auto',
        height: 56,
        display: 'flex',
        alignItems: 'center',
        background: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorder}`,
        padding: '0 4px',
      }}>
        {tabs.map(tab => {
          const active = isActive(tab.key);
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => navigate(tab.key)}
              style={{
                ...btnBase,
                flex: 1,
                color: active ? token.colorPrimary : token.colorTextTertiary,
                fontWeight: active ? 600 : 400,
              }}
            >
              <span style={{ fontSize: 22, lineHeight: 1 }}>{tab.icon}</span>
              <span style={{ fontSize: 10, lineHeight: 1, fontWeight: active ? 600 : 400 }}>
                {tab.label}
              </span>
            </button>
          );
        })}

        {/* Notification bell */}
        <button
          type="button"
          onClick={onOpenRequests}
          style={{
            ...btnBase,
            flex: 1,
            color: pendingCount > 0 ? token.colorPrimary : token.colorTextTertiary,
          }}
        >
          <Badge count={pendingCount} size="small" offset={[4, 0]}>
            <BellOutlined style={{ fontSize: 22 }} />
          </Badge>
          <span style={{ fontSize: 10, lineHeight: 1 }}>
            {formatMessage({ id: 'layout.requests' })}
          </span>
        </button>

      </div>
    </div>
  );
}

export default BottomNav;
